import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./registrercourse.css";

const Registrercourse = ({ redirectToQuizStart = false }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatpass, setRepeatpass] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (redirectToQuizStart) {
      navigate('/quiz-start');
      return;
    }

    setIsLoading(true);

    // validare simplă email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMessage("Adresa de email este invalida");
      setIsLoading(false);
      return;
    }

    // validare simplă parolă
    if (password.length < 8) {
      setErrorMessage("Parola trebuie sa aiba cel putin 8 caractere");
      setIsLoading(false);
      return;
    }
    if (password !== repeatpass) {
      setErrorMessage("Parolele nu se potrivesc");
      setIsLoading(false);
      return;
    }

    const userData = { username, email, password };

    fetch(`${apiUrl}/accounts`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((errorData) => {
            throw new Error(errorData.message || "A aparut o eroare");
          });
        }
        return response.json();
      })
      .then((data) => {
        setUsername("");
        setEmail("");
        setPassword("");
        setRepeatpass("");
        setSuccessMessage(data?.message || "Contul a fost creat cu succes! Verifica emailul pentru confirmare.");
        setErrorMessage("");
      })
      .catch((error) => {
        setErrorMessage(error.message);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="rc-container">
      <form className="rc-form" onSubmit={handleSubmit}>
  

        <input
          type="text"
          placeholder="Nume / prenume"
          className="rc-input"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <input
          type="email"
          placeholder="Email"
          className="rc-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Parola"
          className="rc-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Reintrodu parola"
          className="rc-input"
          value={repeatpass}
          onChange={(e) => setRepeatpass(e.target.value)}
          required
        />

        <button type="submit" className="rc-button-special" disabled={isLoading}>
          <span>{isLoading ? "Se înregistreaza..." : "Creeaza cont"}</span>
        </button>

   
      </form>

      {successMessage && <div className="rc-success">{successMessage}</div>}
      {errorMessage && <div className="rc-error">{errorMessage}</div>}
    </div>
  );
};

export default Registrercourse;
